import { render, staticRenderFns } from "./DonationAllocationPicker.vue?vue&type=template&id=337200c8&scoped=true&"
import script from "./DonationAllocationPicker.vue?vue&type=script&lang=js&"
export * from "./DonationAllocationPicker.vue?vue&type=script&lang=js&"
import style0 from "./DonationAllocationPicker.vue?vue&type=style&index=0&id=337200c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337200c8",
  null
  
)

export default component.exports